var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"page-title":_vm.pageTitle}}),_vm._t("default"),(_vm.entry.collection.id == 'news')?_c('hr'):_vm._e(),_c('PageFooter')],2)}
var staticRenderFns = []

export { render, staticRenderFns }